export const GOAL_COUNT_PER_PAGE = 5;
export const TOTAL_CURRENT_POSITIONS = 10;
